/**
 * Status shared by source documents, digitisation runs and enrichment runs.
 * Allowed moves are set in SQL: `public.is_processing_status_transition_allowed`
 * for runs, and `public.is_source_document_status_transition_allowed` for
 * documents, where a failed document goes back to pending, not processing.
 * `awaiting_review` is a document's alone: runs never take it.
 */
export enum ProcessingStatus {
  Pending = 'pending',
  Deferred = 'deferred',
  Processing = 'processing',
  AwaitingReview = 'awaiting_review',
  Processed = 'processed',
  Failed = 'failed',
  Rejected = 'rejected',
}

/** What a person decided the answers written by hand on a document are. */
export enum HandwritingTreatment {
  /** A response to the paper, such as a student's, left out of the reading. */
  Ignore = 'ignore',
  /** The paper's solutions, such as a teacher's, read as printed ones are. */
  UseAsSolutions = 'use_as_solutions',
}
